<script>
  import { onMount } from 'svelte';

  import { pages } from '../../config';
  import { goto } from '../../util';
  import Dialogs from './dialogs.svelte';
  import FlipAccountView from './flip-account-view.svelte';
  import Highlights from './highlights.svelte';
  import {
    deleteSiteSvc,
    editSiteSvc,
    getForms,
    getSites,
  } from '../../services';
    import SiteSelector from './components/site-selector.svelte';
    import BreadcrumbNav from '../components/breadcrumb-nav.svelte';

  let action = null;
  let activeData = null;
  let selectedForm = null;
  let selectedSite = null;

  $: sites = [];
  $: forms = [];
  $: currentSite = sites.find((s) => s._id === selectedSite);
  $: siteName = currentSite?.domain || null;

  onMount(async () => {
    sites = await getSites();
    forms = await getForms();
  });

  function onCancel(ev) {
    console.log('canceled', ev.detail?.action);
    console.log(ev.detail);
    action = null;
    activeData = null;
  }
  async function onConfirm(ev) {
    if (ev.detail.action === 'showDeleteSiteConfirm') {
      await deleteSiteSvc({ id: ev.detail?.form?.id });
    }

    if (ev.detail.action === 'showEditSiteForm') {
      const newSiteName = ev.detail?.form?.domain;
      const sid = ev.detail?.form?.id;

      if (newSiteName && siteName !== newSiteName) {
        console.info(
          'site updated',
          await editSiteSvc({ sid, domain: newSiteName })
        );
      }
    }

    // Reset all metrics
    selectedSite = null;
    selectedForm = null;
    sites = await getSites();
    forms = await getForms();

    action = null;
    activeData = null;
  }
  function goToList() {
    goto(pages.account.list.url);
  }
</script>

<div class="nav">
  <BreadcrumbNav current="Account Overview" />
  <div>
    <FlipAccountView mode="list" onOverviewClick={goToList} />
  </div>
</div>

<Dialogs {action} {activeData} on:confirm={onConfirm} on:cancel={onCancel} />

<!-- highlights -->
<Highlights />

<hgroup>
  <h2>Account Overview - Coming Soon</h2>
  <h4>Choose the account list option to manage your account.</h4>
</hgroup>
<!-- <SiteSelector /> -->


<style>
  :root {
    --icon-size: 2rem;
  }
  :global([disabled]) {
    opacity: 0.15;
  }
  :global(.delete-btn) {
    background: maroon;
  }
  :global(.fe-icon > svg) {
    stroke-width: var(--stroke-width);
    width: var(--icon-size);
    height: var(--icon-size);
  }
</style>
